var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { FormControlValidators, FormControlASyncValidators } from 'app/models/validators/validator';
import { BaseModalComponent } from "app/views/modal/base_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { HelperService } from "../../lib/helper.service";
import { SupportService } from "../../support/support/support.service";
import { BaseFormGroup } from "../../models/form";
var RoleFormComponent = /** @class */ (function (_super) {
    __extends(RoleFormComponent, _super);
    function RoleFormComponent(activeModal, helper, supportService, asyncValidators) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.helper = helper;
        _this.supportService = supportService;
        _this.asyncValidators = asyncValidators;
        _this.providerNameList = [];
        _this.roleNameList = [];
        _this.isBtnOkActive = false;
        _this.form = new BaseFormGroup({
            _id: new FormControl(''),
            email: new FormControl('', [
                FormControlValidators.required(),
                FormControlValidators.email(),
            ]),
            allows: new FormArray([]),
            userId: new FormControl(''),
        });
        var me = _this;
        me.email.setAsyncValidators(_this.asyncValidators.emailExists());
        return _this;
    }
    Object.defineProperty(RoleFormComponent.prototype, "email", {
        get: function () { return this.form.get('email'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoleFormComponent.prototype, "allows", {
        get: function () { return this.form.get('allows'); },
        enumerable: true,
        configurable: true
    });
    // Это не магия, это API!
    RoleFormComponent.prototype.ok = function () {
        var me = this;
        if (me.form.status === 'VALID') {
            me.activeModal.close(me.form.value);
            return;
        }
    };
    RoleFormComponent.prototype.deleteRole = function (allow) {
        var idx = this.allows.value.findIndex(function (a) { return a.role === allow.get('role').value; });
        if (idx === -1) {
            return;
        }
        this.allows.removeAt(idx);
    };
    RoleFormComponent.prototype.getNewAllowGroup = function (providerName, role) {
        if (providerName === void 0) { providerName = ''; }
        if (role === void 0) { role = 'guest'; }
        return new FormGroup({
            providerName: new FormControl(providerName),
            role: new FormControl(role, [
                FormControlValidators.required()
            ]),
        });
    };
    RoleFormComponent.prototype.addAllow = function () {
        this.allows.push(this.getNewAllowGroup());
    };
    // Что это за Кончита Вурст?!?!?!
    RoleFormComponent.prototype.setRole = function (role) {
        var _this = this;
        this.form.patchValue(role);
        var allows = this.form.get('allows');
        role.allows.forEach(function (a) {
            allows.push(_this.getNewAllowGroup(a.providerName, a.role));
        });
    };
    return RoleFormComponent;
}(BaseModalComponent));
export { RoleFormComponent };
